import { URL_ME, API_WALLET_URL } from 'config'
import { apiCall } from './base'

export const sendOTP = (data) =>
  apiCall(`${URL_ME}/api/v1/me/security/send-otp`, {
    baseURL: API_WALLET_URL,
    method: 'POST',
    withCredentials: false,
    immediately: true,
    data
  })
